import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[disableControl]'
})
export class DisableControlDirective {
  @Input() set disableControl(condition: boolean) {
    const action = condition ? 'disable' : 'enable';

    // Safely defer to allow form control binding
    setTimeout(() => {
      const control = this.ngControl?.control;
      if (control && typeof control[action] === 'function') {
        control[action]();
      }
    });
  }

  constructor(private ngControl: NgControl) {}
}